import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";

export const getRegions = createAsyncThunk(
  "regions/getRegions",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().regions;
      if (state.count.getRegions <= 1) {
        const res = await axios.get("/regions", { params: reqData });
        return res.data;
      }
      return state.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const addRegion = createAsyncThunk(
  "regions/addRegion",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-region", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const editRegion = createAsyncThunk(
  "regions/editRegion",
  async ({ id, reqData }, { rejectWithValue }) => {
    try {
      const res = await axios.put("/edit-region" + id, reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const deleteRegion = createAsyncThunk(
  "regions/deleteRegion",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.delete("/delete-region/" + reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

const regionsSlice = createSlice({
  name: "regions",
  initialState: {
    data: [],
    selected: {},
    loading: false,
    error: null,
    load: {
      getRegions: false,
      getRegion: false,
      addRegion: false,
      editRegion: false,
      deleteRegion: false,
    },
    count: { getRegions: 0, getRegion: 0 },
  },
  reducers: {
    setRegions: (state, action) => {
      state.data = action.payload;
    },
    setSelectedRegion: (state, action) => {
      state.selected = action.payload;
    },
    unsetRegions: (state) => {
      state.data = [];
      state.selected = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Get all Regions
      .addCase(getRegions.pending, (state) => {
        state.load.getRegions = true;
        state.error = null;
        state.count.getRegions = ++state.count.getRegions;
      })
      .addCase(getRegions.fulfilled, (state, action) => {
        state.load.getRegions = false;
        state.data = action.payload;
        state.count.getRegions = 0;
      })
      .addCase(getRegions.rejected, (state, action) => {
        state.load.getRegions = false;
        state.error = action.error;
        state.count.getRegions = 0;
      })
      //Add Region
      .addCase(addRegion.pending, (state) => {
        state.load.addRegion = true;
        state.error = null;
      })
      .addCase(addRegion.fulfilled, (state, action) => {
        state.load.addRegion = false;
        state.data.unshift(action.payload);
      })
      .addCase(addRegion.rejected, (state, action) => {
        state.load.addRegion = false;
        state.error = action.error;
      })
      //Update Region
      .addCase(editRegion.pending, (state) => {
        state.load.editRegion = true;
        state.error = null;
      })
      .addCase(editRegion.fulfilled, (state, action) => {
        state.load.editRegion = false;
        const index = state.data.findIndex(
          (item) => (item.id = action.payload.id)
        );
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editRegion.rejected, (state, action) => {
        state.load.editRegion = false;
        state.error = action.error;
      })
      //Delete Region
      .addCase(deleteRegion.pending, (state) => {
        state.load.deleteRegion = true;
        state.error = null;
      })
      .addCase(deleteRegion.fulfilled, (state, action) => {
        state.load.deleteRegion = false;
        state.data.filter((item) => item.id !== action.meta.arg.id);
      })
      .addCase(deleteRegion.rejected, (state, action) => {
        state.load.deleteRegion = false;
        state.error = action.error;
      });
  },
});

export const { setRegions, setSelectedRegion, unsetRegions } =
  regionsSlice.actions;
export default regionsSlice.reducer;
